import {imageHeightHandle} from '@pages/micro-detail/views/main/utils';
import {isNaComponent} from '../../utils/index';

export default {
    namespaced: true,

    state: {
        // 预加载图片+内容高度（图片高度+160）
        preImgHeight: '',
        // 是否是预加载
        isIframePre: false,
        // 图片预渲染高度
        swiperPreHeight: 0,
        // 是否有预加载
        isPreload: false,
        // 预加载的iframe地址
        IframeLink: ''
    },

    getters: {
        preImgHeight: state => state.preImgHeight,
        isIframePre: state => state.isIframePre,
        swiperPreHeight: state => state.swiperPreHeight,
        isPreload: state => state.isPreload,
        IframeLink: state => state.IframeLink
    },

    mutations: {
        setPreImgHeight(state, params) {
            state.preImgHeight = params;
        },
        setIsIframePre(state, params) {
            state.isIframePre = params;
        },
        setSwiperPreHeight(state, params) {
            state.swiperPreHeight = params;
        },
        setIsPreload(state, params) {
            state.isPreload = params;
        },
        setIframeLink(state, params) {
            state.IframeLink = params;
        }
    },

    actions: {
        // 页面预加载处理
        prePageHandle({state, rootState, commit}) {
            const {url} = rootState;
            let preloadInfo = '';

            if (url.isPreloader) {
                preloadInfo = decodeURIComponent(url.urlParams.preloadInfo) || {};
            }
            else {
                preloadInfo = url.urlParams.preloadInfo || {};
            }

            if (preloadInfo === '') {
                return;
            }
            let preInfo = {
                cover: {}
            };
            try {
                preInfo
                = preloadInfo && typeof preloadInfo === 'string' ? JSON.parse(preloadInfo) : {
                        cover: {}
                    };
            }
            catch (err) {
                console.error('解析错误：', err);
                // 参数解析异常，直接返回，不做预渲染
                return;
            }
            const {
                cover: {src: imgSrc = '', height: imgH = 1454, width: imgW = 1101} = {},
                headline = '',
                content = '',
                iframe: {status = 0, imageSizeRadio = 1, url: iframeSrc = ''} = {}
            } = preInfo || {};
            // 如果预加载不存在标题和内容，则不进行预渲染
            if (headline === '' && content === '') {
                return;
            }
            const isIframePre = status ? Number(status) : 0;
            commit('setIsIframePre', isIframePre);
            const winWidth = window.innerWidth;
            let imgHeight = 0;
            if (imgH && imgW) {
                // 计算预加载图片的高度，最大高度限制552px
                imgHeight = Number(((winWidth * imgH) / imgW).toFixed(2));
                imgHeight = 494;
                if (imgHeight > 552) {
                    imgHeight = 552;
                }
                // 非iframe数据，设置页面首屏预渲染
                if (!state.isIframePre && !iframeSrc) {
                    const preH = imageHeightHandle(imgW, imgH);
                    commit('setSwiperPreHeight', preH);
                    commit('setIsPreload', true);
                    const dataList = [{
                        actionBar: {
                            author: {}
                        },
                        body: {
                            album: {
                                content: [{src: imgSrc, height: imgH, width: imgW}]
                            },
                            article: {
                                content: decodeURIComponent(content),
                                headline
                            },
                            imgList: [imgSrc],
                            content_type: 'article',
                            cover: {
                                fallbackSrc: imgSrc,
                                height: imgH,
                                src: imgSrc,
                                width: imgW
                            }
                        },
                        shareObj: {}
                    }];
                    this.commit('dataList/setDataList', {data: dataList});
                }
                // 如果是组件包或者实验组，则设置携程数据的预渲染
                if ((rootState.url.abtest.includes('107537') || isNaComponent()) && state.isIframePre && iframeSrc) {
                    commit('setIsPreload', true);
                    const iframeDataList = [{
                        actionBar: {
                            author: {}
                        },
                        body: {
                            album: {
                                content: []
                            },
                            article: {
                                content: decodeURIComponent(content),
                                headline
                            },
                            imgList: [imgSrc],
                            content_type: 'article',
                            cover: {},
                            thirdUrl: iframeSrc
                        },
                        guide: {
                            message: ''
                        },
                        comment_num: 0,
                        isIframePage: true,
                        shareObj: {}
                    }];
                    this.commit('dataList/setDataList', {data: iframeDataList});
                }
            }
            let preImgHeight = imgHeight;
            // 针对外部链接且需单独计算图片容器高度
            if (state.isIframePre && imageSizeRadio) {
                preImgHeight = Math.ceil(winWidth / imageSizeRadio);
            }
            // 预留高度为图片高度加160
            preImgHeight = preImgHeight + 160;
            // 预加载图片高度放到store中存储
            commit('setPreImgHeight', preImgHeight);
            commit('setIframeLink', iframeSrc || '');
        }
    }
};